const SCHOOL_TYPE_NAME_BY_CATEGORY_TREE_ID: Record<string, string> = {
  '100': 'KINDERGARTEN',
  '101': 'PRIMARY',
  '102': 'MIDDLE',
  '103': 'HIGH',
  '106': 'COLLEGE',
  '109': 'OTHER',
};

const SCHOOL_TYPE_NAME_BY_LEGACY_CODE: Record<string, string> = {
  '0': 'KINDERGARTEN',
  '1': 'PRIMARY',
  '2': 'MIDDLE',
  '3': 'HIGH',
  '6': 'COLLEGE',
  '9': 'OTHER',
};

const SCHOOL_TYPE_NAME_ALIASES: Record<string, string> = {
  ELEMENTARY: 'PRIMARY',
  UNIVERSITY: 'COLLEGE',
  GRADUATE: 'COLLEGE',
};

export const normalizePublicSchoolType = (schoolType?: string) => {
  const normalizedSchoolType = schoolType?.trim().toUpperCase();
  if (!normalizedSchoolType) return '';

  return (
    SCHOOL_TYPE_NAME_BY_CATEGORY_TREE_ID[normalizedSchoolType] ??
    SCHOOL_TYPE_NAME_BY_LEGACY_CODE[normalizedSchoolType] ??
    SCHOOL_TYPE_NAME_ALIASES[normalizedSchoolType] ??
    normalizedSchoolType
  );
};

export const normalizePublicGradeId = (gradeId: string) => {
  const normalizedGradeId = gradeId.trim();

  return /^\d{5}$/.test(normalizedGradeId)
    ? normalizedGradeId.slice(-2)
    : normalizedGradeId;
};
